import { createContext } from 'react';

import {
  TPrototypeShortDto,
  TUrlSimulationPrototypeResponseDto,
} from '@app-velocity/av-api-v2';

export type FigmaReportsFilters = {
  file?: string | null;
  page?: string | null;
  flow?: string | null;
  owner?: string | null;
  date?: string | null;
  from?: string | null;
  to?: string | null;
  category?: string | null;
};

export type VibeReportsFilters = {
  owner?: string | null;
  date?: string | null;
  from?: string | null;
  to?: string | null;
  url?: string | null;
};

export type MyReportsContextType = {
  figmaPrototypes: TPrototypeShortDto[];
  vibeCheckPrototypes: TUrlSimulationPrototypeResponseDto[];
  figmaTotalElements: number;
  vibeTotalElements: number;
  hasMoreFigmaReports: boolean;
  hasMoreVibeReports: boolean;
  isFetchingMoreFigmaReports: boolean;
  isFetchingMoreVibeReports: boolean;
  fetchMoreFigmaReports: () => void;
  fetchMoreVibeReports: () => void;
  isFigmaLoading: boolean;
  isVibeLoading: boolean;
  figmaFilters: FigmaReportsFilters;
  vibeFilters: VibeReportsFilters;
};

export const MyReportsContext = createContext<MyReportsContextType>({
  figmaPrototypes: [],
  vibeCheckPrototypes: [],
  figmaTotalElements: 0,
  vibeTotalElements: 0,
  hasMoreFigmaReports: false,
  hasMoreVibeReports: false,
  isFetchingMoreFigmaReports: false,
  isFetchingMoreVibeReports: false,
  fetchMoreFigmaReports: () => undefined,
  fetchMoreVibeReports: () => undefined,
  isFigmaLoading: false,
  isVibeLoading: false,
  figmaFilters: {},
  vibeFilters: {},
});
